import { render } from "./TargetTestModal.vue?vue&type=template&id=635f3f66"
import script from "./TargetTestModal.vue?vue&type=script&lang=js"
export * from "./TargetTestModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__